import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { refreshAccessToken } from './axiosApi';

export const createBaseQueryWithReauth = (baseUrl) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('access_token');
      if (token) {
        headers.set('Authorization', `JWT ${token}`);
      }
      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    const usedToken = localStorage.getItem('access_token');
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error?.status !== 401) return result;

    try {
      await refreshAccessToken(usedToken);
    } catch (err) {
      return result;
    }

    return rawBaseQuery(args, api, extraOptions);
  };
};
